import { cn } from "@/lib/utils";

/**
 * The app title with the Tenax colors of Marco's design system, the same as
 * Torneino (D-044: ink #0D0E0E, mint #A7F0E4, grey #A9B2AF): "Tenax" in mint and the rest in grey
 * on a dark background (dark mode, login panel); "Tenax" in ink on a light
 * one. A title changed in the settings is shown as it is, in the same colors.
 */
export const TenaxWordmark = ({
  title,
  onDark = false,
  className,
}: {
  title: string;
  /** always on a dark background, whatever the theme (login panel) */
  onDark?: boolean;
  className?: string;
}) => {
  const [first, ...rest] = title.split(" ");
  return (
    <span className={cn("font-semibold whitespace-nowrap", className)}>
      <span
        className={
          onDark ? "text-[#A7F0E4]" : "text-[#0D0E0E] dark:text-[#A7F0E4]"
        }
      >
        {first}
      </span>
      {rest.length ? (
        <span
          className={
            onDark
              ? "text-[#A9B2AF]"
              : "text-muted-foreground dark:text-[#A9B2AF]"
          }
        >
          {" "}
          {rest.join(" ")}
        </span>
      ) : null}
    </span>
  );
};
